import {
  Component,
  OnInit,
  type ElementRef,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { environment } from 'src/environments/environment';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpClient } from '@angular/common/http';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'
};

@Component({
  selector: 'app-buyer-service-quote-list',
  templateUrl: './buyer-service-quote-list.component.html',
  styleUrls: ['./buyer-service-quote-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyerServiceQuoteListComponent implements OnInit {
  @ViewChild('supplierTable') table!: DatatableComponent;
  @ViewChild('archivedSection', { static: false }) archivedSection!: ElementRef;
  @ViewChild('heading', { static: false }) heading!: ElementRef;
  menuTrigger: MatMenuTrigger | null = null;

  showLoader: boolean = false;
  showDetailLoader: boolean = false;
  searchKeyword: string = '';
  userRole!: string;
  archivedLoaded: boolean = false;
  isBuyer: boolean | undefined;
  limit: number = 10;
  offset: number = 0;
  archivedLimit: number = 10;
  archivedOffset: number = 0;
  totalRecords: number = 0;
  archivedTotalRecords: number = 0;
  sortField: string = 'quotationSubmissionDate';
  sortDirection: string = 'DESC';
  docStatus: any;
  fromDate: any;
  toDate: any;
  masterSelected: boolean = false;
  isWrapDescription: boolean = false;
  documentData: any[] = [];
  AllQuotes: any;
  archivedDocumentData: any[] = [];
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedArchivedRfq: number[] = [];
  selectedStatus: string = 'ALL';

  quoteTypeDropdownOpen: boolean = false;

  filterStatuses = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Pending', label: 'Quote' },
    { name: 'Rejected', label: 'Quote' },
    { name: 'ALL', label: 'Quote' },
  ];
  statusColors: { [key: string]: string } = {
    Accepted: '#1ebd60',
    Pending: '#ff9800',
    Rejected: '#FF0000',
  };
  activeIndex: number = this.filterStatuses.length - 1;

  rfqStatuses: any[] = [
    'Unactioned', 'Acknowledged', 'Quoted', 'Under Review',
    'Clarification Requested', 'Approved', 'Rejected', 'Awarded',
    'Closed', 'Open', 'In Review', 'Awaiting Supplier Response',
    'Canceled', 'Draft', 'Declined', 'Lost', 'Created',
  ];

  supplierUsersList: any[] = [];
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;
  showProductPopUp: boolean = false;

  items = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  archivedItems = [
    { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Quote before date', prop: 'quotedByDate', selected: false },
    { label: 'Owner', prop: 'Owner', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  @ViewChild('rowDetailTpl', { static: true }) rowDetailTpl: TemplateRef<any> | undefined;
  quoteLineItemData: any[] = [];
  showProductReqCost: boolean = false;
  showQuoteReqCost: boolean = false;

  isChatOpen: boolean = false;
  headerData: any;
  userId!: number;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup: boolean = false;
  selectedSupplier: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax: 'N/A'
  };

  expandedRowId: number | null = null;
  expandedRowIndex: number | null = null;
  private autoExpandDone: boolean = false;

  exchangeRatesCache: { [base: string]: any } = {};

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private http: HttpClient,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
    );
  }

  operationType: string = 'buyerServiceQuote';

  async ngOnInit() {
    this.userId = Number(this.cookieService.get('userId'));
    this.userRole = this.cookieService.get('userRole');

    this.route.queryParams.subscribe((params) => {
      const statusParam = params['selectedStatus'];
      const labelParam = params['label'];
      if (statusParam && labelParam) {
        this.selectedStatus = statusParam;
        this.docStatus = statusParam;
        this.setActiveStatus(statusParam, labelParam);
      } else {
        this.docStatus = 'ALL';
        this.selectedStatus = 'ALL';
      }
    });

    if (this.userRole == 'Owner') {
      this.isBuyer = true;
    }

    await this.fetchAllDocuments();
  }

  // ===== FETCH ACTIVE DOCUMENTS =====
  async fetchAllDocuments() {
    this.operationType = 'buyerServiceQuote';
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      this.showLoader = true;
      this.fullLoaderService.showLoader();

      const response = await this.SettingsService.fetchAllServiceQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.limit,
        this.offset,
        1, // isActive = 1 for active
        this.operationType
      );

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((rfq: any) => {
          const currentDate = new Date();
          const quotedByDate = new Date(rfq.quotedByDate);
          if (rfq.docStatus === 'Unactioned' && quotedByDate < currentDate) {
            rfq.docStatus = 'Expired';
          }
          if (this.expandedRowId === null) {
            this.expandedRowId = rfq.rfqId;
          }
          // Parse JSON fields if they come as strings
          if (typeof rfq.supplierQuotationList === 'string') {
            try { rfq.supplierQuotationList = JSON.parse(rfq.supplierQuotationList); } catch { rfq.supplierQuotationList = []; }
          }
          if (typeof rfq.buyerAttachments === 'string') {
            try { rfq.buyerAttachments = JSON.parse(rfq.buyerAttachments); } catch { rfq.buyerAttachments = []; }
          }
          if (typeof rfq.lineItemAttachments === 'string') {
            try { rfq.lineItemAttachments = JSON.parse(rfq.lineItemAttachments); } catch { rfq.lineItemAttachments = []; }
          }
          if (typeof rfq.rfqStatusStages === 'string') {
            try { rfq.rfqStatusStages = JSON.parse(rfq.rfqStatusStages); } catch { rfq.rfqStatusStages = []; }
          }
          // Parse nested supplier quotation list JSON fields
          if (Array.isArray(rfq.supplierQuotationList)) {
            rfq.supplierQuotationList.forEach((sq: any) => {
              if (typeof sq.quoteHeaderAttachments === 'string') {
                try { sq.quoteHeaderAttachments = JSON.parse(sq.quoteHeaderAttachments); } catch { sq.quoteHeaderAttachments = []; }
              }
              if (typeof sq.quoteLineItemAttachments === 'string') {
                try { sq.quoteLineItemAttachments = JSON.parse(sq.quoteLineItemAttachments); } catch { sq.quoteLineItemAttachments = []; }
              }
            });
          }
          rfq.statusesStages = this.buildRfqStages(rfq);
          rfq.statusesStages = this.buildOtherStages(rfq);
          return rfq;
        });

        this.documentData = enrichedRows;
        this.documentData = [...this.documentData];
        this.totalRecords = response.totalElements || 0;

        // Auto-expand first row
        if (!this.autoExpandDone && this.documentData.length > 0) {
          setTimeout(() => {
            try {
              const firstRow = this.documentData[0];
              this.expandedRowId = firstRow.rfqId;
              this.expandedRowIndex = 0;
              if (this.table && this.table.rowDetail) {
                try { this.table.rowDetail.collapseAllRows(); } catch {}
                this.table.rowDetail.toggleExpandRow(firstRow);
                this.autoExpandDone = true;
              }
            } catch (e) {
              console.warn('Auto-expand first row failed:', e);
            }
          }, 0);
        }
      }

      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching service quote documents', error);
      this.showLoader = false;
      this.fullLoaderService.hideLoader();
      this.cdr.markForCheck();
    }
  }

  // ===== FETCH ARCHIVED DOCUMENTS =====
  async fetchArchivedAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      const response = await this.SettingsService.fetchAllServiceQuotesByBuyerId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        this.archivedLimit,
        this.archivedOffset,
        0, // isActive = 0 for archived
        'buyerServiceQuote'
      );

      if (response && Array.isArray(response.rows)) {
        const enrichedRows = response.rows.map((rfq: any) => {
          if (typeof rfq.supplierQuotationList === 'string') {
            try { rfq.supplierQuotationList = JSON.parse(rfq.supplierQuotationList); } catch { rfq.supplierQuotationList = []; }
          }
          if (typeof rfq.buyerAttachments === 'string') {
            try { rfq.buyerAttachments = JSON.parse(rfq.buyerAttachments); } catch { rfq.buyerAttachments = []; }
          }
          if (typeof rfq.lineItemAttachments === 'string') {
            try { rfq.lineItemAttachments = JSON.parse(rfq.lineItemAttachments); } catch { rfq.lineItemAttachments = []; }
          }
          if (Array.isArray(rfq.supplierQuotationList)) {
            rfq.supplierQuotationList.forEach((sq: any) => {
              if (typeof sq.quoteHeaderAttachments === 'string') {
                try { sq.quoteHeaderAttachments = JSON.parse(sq.quoteHeaderAttachments); } catch { sq.quoteHeaderAttachments = []; }
              }
              if (typeof sq.quoteLineItemAttachments === 'string') {
                try { sq.quoteLineItemAttachments = JSON.parse(sq.quoteLineItemAttachments); } catch { sq.quoteLineItemAttachments = []; }
              }
            });
          }
          rfq.statusesStages = this.buildRfqStages(rfq);
          rfq.statusesStages = this.buildOtherStages(rfq);
          return rfq;
        });

        this.archivedDocumentData = enrichedRows;
        this.archivedDocumentData = [...this.archivedDocumentData];
        this.archivedTotalRecords = response.totalElements || 0;
      }
      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error fetching archived service quote documents', error);
    }
  }

  // ===== FETCH ALL QUOTES (for export) =====
  async fetchAllQuotes() {
    try {
      const response = await this.SettingsService.fetchBuyerServiceQuoteExportAll(
        Number(this.cookieService.get('userId'))
      );
      if (response && Array.isArray(response)) {
        this.AllQuotes = response;
      }
    } catch (error) {
      console.error('Error fetching all service quotes:', error);
      throw error;
    }
  }

  // ===== TOGGLE DROPDOWN =====
  toggleQuoteTypeDropdown() {
    this.quoteTypeDropdownOpen = !this.quoteTypeDropdownOpen;
  }

  navigateToQuoteType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/buyer-quote-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/buyer-service-quote-list']);
    }
  }

  // ===== STATUS / FILTER =====
  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(
      (s) => s.name === status && s.label === label
    );
    if (index !== -1) {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.docStatus = status;
    } else {
      this.docStatus = 'ALL';
      this.selectedStatus = 'ALL';
    }
  }

  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000';
  }

  onStatusSelect(status: string, index: number, label: string) {
    if (this.selectedStatus.includes(status)) return;
    if (label === 'Quote') {
      this.activeIndex = index;
      this.selectedStatus = status;
      this.offset = 0;
      this.docStatus = status;
      this.fetchAllDocuments();
    }
  }

  // ===== DATE / FORMAT =====
  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment();
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
    else if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;
    else if (diffInHours < 24) return `${diffInHours} hours ago`;
    else if (diffInDays === 1) return 'Yesterday';
    else return moment(rfqDate).format('DD MMM YYYY');
  }

  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  isRFQExpired(quotedByDate: string | Date): boolean {
    if (!quotedByDate) return false;
    return new Date() > new Date(quotedByDate);
  }

  // ===== ROW EXPAND =====
  toggleExpandRow(row: any, index: number) {
    const clickedId = row?.rfqId;
    const isSameRow = this.expandedRowId === clickedId;

    if (this.table && this.table.rowDetail) {
      try { this.table.rowDetail.collapseAllRows(); } catch {}
    }

    if (isSameRow) {
      this.expandedRowId = null;
      this.expandedRowIndex = null;
      return;
    }

    this.expandedRowId = clickedId;
    this.expandedRowIndex = index;

    if (this.table && this.table.rowDetail) {
      this.table.rowDetail.toggleExpandRow(row);
    }
  }

  getRowHeight = (row: any): number => {
    if (this.expandedRowId !== undefined) {
      const expandedRow = this.documentData.find(r => r.rfqId === this.expandedRowId);
      if (expandedRow) {
        const itemCount = expandedRow?.supplierQuotationList?.length || 0;
        if (itemCount === 0) return 266;
        else if (itemCount > 3) return 480;
        else return itemCount * 120 + 266;
      }
    }
    return 100;
  };

  setRowClass = (row: any) => 'green-row-background';
  rowIdentity = (row: any) => row.rfqId;

  // ===== PAGINATION / SORT / SEARCH =====
  onPageChange(event: any) {
    this.offset = event.offset;
    this.selectedRfq = [];
    this.fetchAllDocuments();
  }

  onSearch() {
    this.offset = 0;
    this.fetchAllDocuments();
  }

  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;
    this.fetchArchivedAllDocuments();
  }

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset;
    this.fetchArchivedAllDocuments();
  }

  // ===== COLUMNS =====
  toggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    this.updateArchivedSelectedColumns();
  }

  updateSelectedColumns() {
    this.selectedColumns = this.items
      .filter(item => item.selected)
      .map(item => ({ label: item.label, prop: item.prop }));
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter(item => item.selected)
      .map(item => ({ label: item.label, prop: item.prop }));
  }

  // ===== CHECKBOX SELECTION =====
  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    if (section == 'active') {
      this.selectedRfq = checked ? this.documentData.map(item => item.quoteId) : [];
    } else {
      this.selectedArchivedRfq = checked ? this.archivedDocumentData.map(item => item.quoteId) : [];
    }
  }

  selectDeselectRfq(event: any, supplierRfqDetailsId: any, quoteId: any, section: string, owner: any) {
    const checked = event.target.checked;
    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(quoteId);
        if (owner !== null) {
          this.snack.open(`User is already assigned to Quote ID ${quoteId}`, 'OK', { duration: 5000 });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter(id => id !== quoteId);
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(quoteId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== quoteId);
      }
    }
  }

  isChecked(quoteId: number, section: string) {
    return section == 'active'
      ? this.selectedRfq.includes(quoteId)
      : this.selectedArchivedRfq.includes(quoteId);
  }

  // ===== ARCHIVE / UNARCHIVE =====
  async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select at least one', 'OK', { duration: 3000 });
        return;
      }

      // Extract rfqIds from selected quoteIds
      const selectedQuoteIds = new Set(this.selectedArchivedRfq);
      const rfqIds = this.archivedDocumentData
        .filter((row: any) => selectedQuoteIds.has(row.quoteId))
        .map((row: any) => row.rfqId);

      this.showLoader = true;
      await this.SettingsService.buyerServiceQuoteOperations({
        operation: 'unarchive',
        selectedRfqIds: rfqIds,
      });

      const toUnarchive = this.archivedDocumentData.filter((row: any) => selectedQuoteIds.has(row.quoteId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !selectedQuoteIds.has(row.quoteId));
      this.documentData = [...toUnarchive, ...this.documentData];
      this.totalRecords += toUnarchive.length;
      this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      this.selectedArchivedRfq = [];
      this.showLoader = false;
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else if (operation == 'archive') {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select at least one.', 'OK', { duration: 3000 });
        return;
      }

      const selectedQuoteIds = new Set(this.selectedRfq);
      const rfqIds = this.documentData
        .filter((row: any) => selectedQuoteIds.has(row.quoteId))
        .map((row: any) => row.rfqId);

      this.showLoader = true;
      await this.SettingsService.buyerServiceQuoteOperations({
        operation: 'archive',
        selectedRfqIds: rfqIds,
      });

      const toArchive = this.documentData.filter((row: any) => selectedQuoteIds.has(row.quoteId));
      this.documentData = this.documentData.filter((row: any) => !selectedQuoteIds.has(row.quoteId));
      if (this.archivedLoaded) {
        this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
        this.archivedTotalRecords += toArchive.length;
      }
      this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);
      this.selectedRfq = [];
      this.showLoader = false;
      this.snack.open('Items archived', 'OK', { duration: 3000 });
    }
    this.documentData = [...this.documentData];
    this.archivedDocumentData = [...this.archivedDocumentData];
    this.cdr.markForCheck();
  }

  async restore(quoteId: number, operation: string) {
    if (operation == 'unArchive') {
      const row = this.archivedDocumentData.find((r: any) => r.quoteId === quoteId);
      if (row) {
        await this.SettingsService.buyerServiceQuoteOperations({
          operation: 'unarchive',
          selectedRfqIds: [row.rfqId],
        });

        const idx = this.archivedDocumentData.findIndex((r: any) => r.quoteId === quoteId);
        if (idx !== -1) {
          const [removedRow] = this.archivedDocumentData.splice(idx, 1);
          this.documentData = [removedRow, ...this.documentData];
          this.totalRecords += 1;
          this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
        }
      }
      this.documentData = [...this.documentData];
      this.archivedDocumentData = [...this.archivedDocumentData];
      this.snack.open('Item unarchived', 'OK', { duration: 3000 });
      this.cdr.markForCheck();
    }
  }

  // ===== EXPORT =====
  async exportAllQuotes() {
    try {
      this.fullLoaderService.showLoader('Exporting Service Quote Details...');
      await this.fetchAllQuotes();

      if (!this.AllQuotes || this.AllQuotes.length === 0) {
        this.snack.open('No Service Quotes available to export.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
        return;
      }

      const exportData: any[] = [];

      this.AllQuotes.forEach((row: any, index: number) => {
        exportData.push({
          'Sr. No.': index + 1,
          'RFQ Reference': row.rfqRefNumber || '',
          'Port Name': row.portName || '',
          'Vessel Name': row.vesselName || '',
          'Status': row.docStatus || '',
          'RFQ Date': row.rfqDate ? moment(row.rfqDate).format('DD-MM-YYYY') : '',
          'Request Delivery Date': row.requestDeliveryDate ? moment(row.requestDeliveryDate).format('DD-MM-YYYY') : '',
          'Quote Before Date': row.quotedByDate ? moment(row.quotedByDate).format('DD-MM-YYYY') : '',
          'Vessel ETA': row.vesselEta ? moment(row.vesselEta).format('DD-MM-YYYY') : '',
          'Vessel ETD': row.vesselEtd ? moment(row.vesselEtd).format('DD-MM-YYYY') : '',
          'Total Suppliers': row.rfqSupplierCount || 0,
          'Owner': row.Owner || '',
        });
      });

      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      const fileName = `Buyer_Service_Quotation_List_${formattedDate}.xlsx`;

      const XLSX = await import('xlsx');
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Service Quotes');
      XLSX.writeFile(wb, fileName);

      this.snack.open('Service Quotes data exported successfully!', 'OK', { duration: 5000 });
    } catch (error) {
      console.error('Error exporting service quotes:', error);
      this.snack.open('Failed to export Service Quotes data.', 'OK', { duration: 5000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  // ===== TOGGLE ARCHIVED =====
  toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand && !this.archivedLoaded) {
      this.archivedLoaded = true;
      this.fetchArchivedAllDocuments();
    }
    if (this.isArchivedExpand && this.heading) {
      this.heading.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = 'ALL';
    this.docStatus = 'ALL';
    this.fetchAllDocuments();
  }

  // ===== USER ASSIGNMENT =====
  async toggleUserSelection(item: any) {
    if (this.selectedRfq.length === 0) {
      this.snack.open('Please select at least one Quote before selecting a user.', 'OK', { duration: 3000 });
      return;
    }

    item.selected = !item.selected;

    if (item.selected) {
      try {
        this.fullLoaderService.showLoader('Assigning user...');

        // Extract ALL quoteIds from supplierQuotationList of selected rows
        // so all supplier quotes under each selected RFQ get assigned
        const allQuoteIds: number[] = [];
        const selectedQuoteIds = new Set(this.selectedRfq);
        this.documentData
          .filter((row: any) => selectedQuoteIds.has(row.quoteId))
          .forEach((row: any) => {
            if (Array.isArray(row.supplierQuotationList)) {
              row.supplierQuotationList.forEach((sq: any) => {
                allQuoteIds.push(sq.quoteId);
              });
            }
          });

        await this.SettingsService.assignUserToBuyerServiceQuotes(
          allQuoteIds,
          Number(this.cookieService.get('userId')),
          item.id
        );
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;
        this.snack.open('User assigned to Quote successfully.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
      } catch (error) {
        this.snack.open('Failed to assign user to Quote.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
      }
    }
  }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    if (
      menuContent.scrollTop + menuContent.clientHeight >= menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  async fetchUsers(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')),
        this.userlimit,
        this.useroffset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++;
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async onUserMenuOpened() {
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
  }

  // ===== LINE ITEM POPUP =====
  async fetchQuoteLineItemDetailsByQuoteId(quoteId: number) {
    this.showDetailLoader = true;
    this.showProductPopUp = true;

    try {
      this.quoteLineItemData =
        await this.SettingsService.fetchServiceQuoteLineItemsByBuyer(quoteId);
    } catch (error) {
      console.error('Error fetching service quote line items', error);
    } finally {
      this.showDetailLoader = false;
      this.cdr.markForCheck();
    }
  }

  toggleSidebar(value: boolean, section?: string) {
    if (!value) this.quoteLineItemData = [];
    this.showProductPopUp = value;
  }

  toggleShowColumn(section: string) {
    if (section == 'productCost') this.showProductReqCost = !this.showProductReqCost;
    else if (section == 'quoteCost') this.showQuoteReqCost = !this.showQuoteReqCost;
  }

  // ===== NAVIGATION =====
  openRfqDetails(rfqId: number) {
    this.router.navigate(['/dashboard/rfq/service-rfq-header'], {
      queryParams: { serviceRfqId: rfqId },
    });
  }

  viewQuotePreview(quoteId: number, supplierId: number, rfqId: number) {
    this.router.navigate(['/dashboard/quote/service-quote-details'], {
      queryParams: {
        supplierId: supplierId,
        quoteId: quoteId,
        serviceRfqId: rfqId,
      },
    });
  }

  // ===== DOWNLOAD / PRINT =====
  async downloadRfqForBuyer(refNo: string, row: any) {
    // Use supplier-side API which has correct JOINs for buyer+supplier details
    const supplierId = row.supplierQuotationList?.[0]?.supplierId;
    if (!supplierId) {
      this.snack.open('No supplier found for this RFQ.', 'OK', { duration: 3000 });
      return;
    }
    this.fullLoaderService.showLoader('Downloading RFQ PDF...');
    try {
      const fileName = refNo + '.pdf';
      const pdf = await this.SettingsService.generateSupplierServiceRfqAttachment(
        row.rfqId,
        supplierId
      );
      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.snack.open('RFQ PDF downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error downloading Service RFQ PDF:', error);
      this.snack.open('Error downloading RFQ PDF. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async downloadQuote(row: any, supplier: any) {
    this.fullLoaderService.showLoader('Downloading Quote PDF...');
    try {
      const fileName = (supplier.quoteRefNumber || 'Quote') + '.pdf';
      const params = {
        supplierId: Number(supplier.supplierId),
        serviceRfqId: Number(row.rfqId),
        quoteId: Number(supplier.quoteId),
      };
      const pdf = await this.SettingsService.generateServiceQuotationAttachment(params);
      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.snack.open('Quote PDF downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error downloading Quote PDF:', error);
      this.snack.open('Error downloading Quote PDF. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async generateRFQExcelForBuyer(rfqId: number) {
    // Use supplier-side API which has correct JOINs for buyer+supplier details
    const rowData = this.documentData.find((r: any) => r.rfqId === rfqId);
    const supplierId = rowData?.supplierQuotationList?.[0]?.supplierId;
    if (!supplierId) {
      this.snack.open('No supplier found for this RFQ.', 'OK', { duration: 3000 });
      return;
    }
    this.fullLoaderService.showLoader('Generating RFQ Excel...');
    try {
      const refNo = rowData?.rfqRefNumber || 'ServiceRFQ';

      const result = await this.SettingsService.fetchServiceRfqDetailsForExcel(
        rfqId,
        supplierId
      );

      if (!result || !result.rfqData || result.rfqData.length === 0) {
        this.snack.open('No data found for this Service RFQ.', 'OK', { duration: 3000 });
        return;
      }

      const fileName = refNo + '.xlsx';
      const rfqData = result.rfqData[0];
      const lineItemData = result.lineItemData || [];

      const formatDate = (val: any) => {
        if (!val) return '';
        const d = moment(val);
        return d.isValid() ? d.format('DD/MM/YYYY') : '';
      };

      const data = {
        rfqRef: rfqData.serviceRfqRefNumber || '',
        rfqDate: formatDate(rfqData.serviceRfqDate),
        preferredCurrency: rfqData.currencyCode || '',
        vesselName: rfqData.vesselName || '',
        imoNumber: rfqData.vesselImoNumber || '',
        quoteByDate: formatDate(rfqData.quoteByDate),
        requestedDeliveryDate: formatDate(rfqData.requestedDeliveryDate),
        buyerDetails: {
          name: rfqData.buyerCompanyName || '',
          address: rfqData.buyerAddress || '',
          contact: rfqData.buyerContact || '',
          phone: rfqData.buyerPhone || '',
          email: rfqData.buyerEmail || '',
        },
        supplierDetails: {
          name: rfqData.supplierCompanyName || '',
          address: rfqData.supplierAddress || '',
          contact: rfqData.supplierName || '',
          phone: rfqData.supplierPhone || '',
          email: rfqData.supplierEmail || '',
        },
        freightForwarderDetails: {
          PIC: rfqData.freightForwarderPic || '',
          phone: rfqData.freightForwarderPhone || '',
          fax: rfqData.freightForwarderFax || '',
          email: rfqData.freightForwarderEmail || '',
          address: rfqData.freightForwarderAddress || '',
        },
        portAgentDetails: {
          name: rfqData.portAgentName || '',
          phone: rfqData.portAgentPhone || '',
          fax: rfqData.portAgentFax || '',
          email: rfqData.portAgentEmail || '',
          contact: rfqData.portAgentContact || '',
        },
        portDetails: {
          portName: rfqData.portName || '',
          vesselETA: formatDate(rfqData.vesselEta),
          vesselETD: formatDate(rfqData.vesselEtd),
        },
        lineItems: lineItemData.map((item: any, index: number) => ({
          srNo: index + 1,
          serviceCode: item.serviceCode || item.serviceName || '',
          serviceDescription: item.serviceDescription || '',
          qty: item.quantity || '',
          uom: item.uom || '',
          buyerComments: item.buyerComments || '',
        })),
      };

      const Excel = await import('exceljs');
      const fileSaverMod = await import('file-saver');
      const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
      const workbook = new Excel.Workbook();
      const ws = workbook.addWorksheet('Service RFQ');

      ws.mergeCells('A1:G1');
      const title = ws.getCell('A1');
      title.value = 'Service Request For Quotation';
      title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
      title.alignment = { horizontal: 'center', vertical: 'middle' };
      ws.addRow([]);

      const rfqHeader = ws.addRow(['SERVICE RFQ DETAILS']);
      rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      rfqHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const rfqInfo = [
        ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
        ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
        ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
        ['Requested Delivery Date:', data.requestedDeliveryDate],
      ];
      rfqInfo.forEach((r) => {
        const row = ws.addRow(r);
        row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
      });
      ws.addRow([]);

      const bsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      bsHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);

      const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value,
      ]);
      const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value,
      ]);
      const maxLen = Math.max(buyerEntries.length, supplierEntries.length);
      for (let i = 0; i < maxLen; i++) {
        const b = buyerEntries[i] || ['', ''];
        const s = supplierEntries[i] || ['', ''];
        ws.addRow([b[0], b[1], '', s[0], s[1]]);
      }
      ws.addRow([]);

      const ffHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
      ffHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
      });
      ws.addRow([]);

      const ffEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value,
      ]);
      const paEntries = Object.entries(data.portAgentDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value,
      ]);
      const maxLen2 = Math.max(ffEntries.length, paEntries.length);
      for (let i = 0; i < maxLen2; i++) {
        const f = ffEntries[i] || ['', ''];
        const p = paEntries[i] || ['', ''];
        ws.addRow([f[0], f[1], '', p[0], p[1]]);
      }
      ws.addRow([]);

      const portHeader = ws.addRow(['Port Details']);
      portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      portHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const portEntries = Object.entries(data.portDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value,
      ]);
      portEntries.forEach((e) => ws.addRow(e));
      ws.addRow([]);

      const lineHeader = ws.addRow(['SERVICE LINE ITEMS']);
      lineHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DDEBF7' } };
      lineHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const itemHeader = ws.addRow(['Sr.No', 'Service Code', 'Service Description', 'Qty', 'UOM', 'Buyer Comments']);
      itemHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
        c.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      data.lineItems.forEach((item: any) => {
        const row = ws.addRow([
          item.srNo, item.serviceCode, item.serviceDescription,
          item.qty, item.uom, item.buyerComments,
        ]);
        row.eachCell((c: any) => {
          c.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });

      ws.columns = [
        { width: 20 }, { width: 25 }, { width: 35 },
        { width: 10 }, { width: 10 }, { width: 30 }, { width: 20 },
      ];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
      this.snack.open('RFQ Excel downloaded successfully.', 'OK', { duration: 3000 });
    } catch (error) {
      console.error('Error generating Service RFQ Excel:', error);
      this.snack.open('Error generating RFQ Excel. Please try again.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  async generateQuoteExcel(quoteId: number, rfqId: number, supplierId: number, ref: string) {
    this.fullLoaderService.showLoader('Generating Quote Excel...');
    const fileName = ref + '.xlsx';
    const params = {
      supplierId: Number(supplierId),
      serviceRfqId: Number(rfqId),
      quoteId: Number(quoteId),
    };

    try {
      const result = await this.SettingsService.fetchServiceQuoteAttachmentExcelData(params);

      const data = {
        quoteDetails: {
          quoteRef: result.quoteData.quoteRefNumber,
          quotedDate: result.quoteData.quotationDate,
          pricesGoodUntil: result.quoteData.pricesGoodUntil,
          offeredQuality: result.quoteData.offeredQualityName,
          currency: result.quoteData.currencyCode,
          onTimeDeliveryOrderBy: result.quoteData.onTimeDeliveryOrderBy,
          quotedDeliveryInDays: result.quoteData.quotedDeliveryInDays,
          incoterms: result.quoteData.incotermsName,
          incotermsLocation: result.quoteData.incotermLocations,
          paymentTerms: result.quoteData.paymentTermsCondition,
          termsAndCondition: this.convertHtmlToPlainText(result.quoteData.termsAndConditions)
        },
        rfqDetails: {
          rfqRef: result.quoteData.rfqRefNumber,
          vesselName: result.quoteData.vesselName,
          imoNumber: result.quoteData.vesselImoNumber,
          requestedDeliveryDate: result.quoteData.requestDeliveryDate,
        },
        buyerDetails: {
          name: result.quoteData.buyerCompanyName,
          address: result.quoteData.buyerCompanyAddress,
          contact: result.quoteData.buyerContact,
          phone: result.quoteData.buyerCompanyPhone,
          email: result.quoteData.buyerCompanyEmail,
          mpsBuyerCode: result.quoteData.buyerMpsCode,
        },
        supplierDetails: {
          name: result.quoteData.supplierCompanyName,
          address: `${result.quoteData.supplierStreet || ''}, ${result.quoteData.supplierCity || ''}, ${result.quoteData.supplierCountry || ''}, ${result.quoteData.supplierZipcode || ''}`,
          contact: result.quoteData.supplierContact,
          phone: result.quoteData.supplierPhone,
          email: result.quoteData.supplierEmail,
          mpsSupplierCode: result.quoteData.supplierMpsCode,
        },
        freightForwarderDetails: {
          PIC: result.quoteData.qffpic,
          phone: result.quoteData.qffphone,
          fax: result.quoteData.qfffax,
          email: result.quoteData.qffemailId,
          address: result.quoteData.qffaddress,
        },
        portDetails: {
          portName: result.quoteData.portName,
          vesselETA: result.quoteData.vesselEta,
          vesselETD: result.quoteData.vesselEtd,
        },
        costSummary: {
          lineItemSubtotal: parseFloat(result.quoteData.lineItemSubtotal || 0).toFixed(3),
          generalDiscountType: result.quoteData.generalDiscountType || 'percentage',
          generalDiscountValue: parseFloat(result.quoteData.generalDiscountValue || 0),
          generalDiscountAmount: (result.quoteData.generalDiscountType || 'percentage') === 'percentage'
            ? (parseFloat(result.quoteData.lineItemSubtotal || 0) * parseFloat(result.quoteData.generalDiscountValue || 0) / 100).toFixed(3)
            : parseFloat(result.quoteData.generalDiscountValue || 0).toFixed(3),
          taxAmount: parseFloat(result.quoteData.taxAmount || 0).toFixed(3),
          otherCharges: result.quoteData.quoteLineItemFreight,
          totalAdditionalCost: parseFloat(result.quoteData.freightValue || 0).toFixed(3),
          currency: result.quoteData.currencyCode,
          grandTotal: parseFloat(result.quoteData.subtotal || 0).toFixed(3)
        },
        lineItems: result.lineItemData.map((item: any, index: number) => ({
          srNo: index + 1,
          serviceName: item.serviceName,
          serviceDescription: item.serviceDescription,
          requestedQty: item.quantity,
          quotedQuantity: item.supplierQuantity,
          requestedUom: item.uom,
          quotedUom: item.supplierUom,
          unitCost: item.unitCost,
          discount: item.discount,
          totalCost: item.totalCost,
          leadDays: item.leadTime,
          supplierRemarks: item.supplierComment || ''
        }))
      };

      const Excel = await import('exceljs');
      const fileSaverMod = await import('file-saver');
      const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
      const workbook = new Excel.Workbook();
      const ws = workbook.addWorksheet('Quotation');

      // === TITLE ===
      ws.mergeCells('A1:G1');
      const title = ws.getCell('A1');
      title.value = 'Service Quotation';
      title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
      title.alignment = { horizontal: 'center', vertical: 'middle' };
      ws.addRow([]);

      // === QUOTATION DETAILS ===
      const quoteHeader = ws.addRow(['QUOTATION DETAILS']);
      quoteHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      quoteHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const quoteInfo = [
        ['Quote Ref:', data.quoteDetails.quoteRef, '', 'On-Time Delivery Order By:', data.quoteDetails.onTimeDeliveryOrderBy],
        ['Quoted Date:', data.quoteDetails.quotedDate, '', 'Quoted Delivery in Days:', data.quoteDetails.quotedDeliveryInDays],
        ['Prices Good Until:', data.quoteDetails.pricesGoodUntil, '', 'Incoterms:', data.quoteDetails.incoterms],
        ['Offered Quality:', data.quoteDetails.offeredQuality, '', 'Incoterms Location:', data.quoteDetails.incotermsLocation],
        ['Currency:', data.quoteDetails.currency, '', 'Payment Terms:', data.quoteDetails.paymentTerms],
      ];
      quoteInfo.forEach((r) => {
        const row = ws.addRow(r);
        row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
      });
      ws.addRow([]);

      // === BUYER AND SUPPLIER DETAILS ===
      const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
      BsHeader.eachCell((c: any) => {
        c.font = { bold: true };
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF2CC' } };
      });
      ws.addRow([]);

      const qBuyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value
      ]);
      const qSupplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
        labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, (s: string) => s.toUpperCase()),
        value
      ]);
      const BsmaxRows = Math.max(qBuyerEntries.length, qSupplierEntries.length);
      const paddedBuyer = [...qBuyerEntries, ...Array(BsmaxRows - qBuyerEntries.length).fill(['', ''])];
      const paddedSupplier = [...qSupplierEntries, ...Array(BsmaxRows - qSupplierEntries.length).fill(['', ''])];

      for (let i = 0; i < BsmaxRows; i++) {
        const row = ws.addRow([
          paddedBuyer[i][0], paddedBuyer[i][1], '',
          paddedSupplier[i][0], paddedSupplier[i][1]
        ]);
        row.eachCell((cell: any) => {
          cell.alignment = { vertical: 'middle', wrapText: true };
        });
      }
      ws.addRow([]);

      // === RFQ DETAILS ===
      const rfqHeader = ws.addRow(['RFQ Details']);
      rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'f9bccb' } };
      rfqHeader.getCell(1).font = { bold: true };
      ws.addRow([]);
      ws.addRow(['RFQ Reference', data.rfqDetails.rfqRef]);
      ws.addRow(['Vessel Name', data.rfqDetails.vesselName]);
      ws.addRow(['Vessel IMO', data.rfqDetails.imoNumber]);
      ws.addRow(['Requested Delivery Date', data.rfqDetails.requestedDeliveryDate]);
      ws.addRow(['Port Name', data.portDetails.portName]);
      ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
      ws.addRow(['Vessel ETD', data.portDetails.vesselETD]);
      ws.addRow([]);
      ws.addRow([]);

      // === FREIGHT DETAILS ===
      const freightHeader = ws.addRow(['Freight Details']);
      freightHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      freightHeader.getCell(1).font = { bold: true };
      ws.addRow([]);
      ws.addRow(['PIC', data.freightForwarderDetails.PIC]);
      ws.addRow(['Phone', data.freightForwarderDetails.phone]);
      ws.addRow(['Fax', data.freightForwarderDetails.fax]);
      ws.addRow(['Email', data.freightForwarderDetails.email]);
      ws.addRow(['Address', data.freightForwarderDetails.address]);
      ws.addRow([]);
      ws.addRow([]);

      // === LINE ITEMS ===
      const liHeader = ws.addRow(['Line Items']);
      liHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
      liHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const tableHeader = ws.addRow([
        'Sr. No', 'Service Name', 'Service Description',
        'Requested Qty', 'Quoted Qty', 'Requested UOM', 'Quoted UOM',
        'Unit Cost', 'Discount', 'Total Cost', 'Lead Days', 'Supplier Remarks'
      ]);
      tableHeader.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      data.lineItems.forEach((item: any) => {
        const row = ws.addRow([
          item.srNo, item.serviceName, item.serviceDescription,
          item.requestedQty, item.quotedQuantity, item.requestedUom, item.quotedUom,
          item.unitCost, item.discount, item.totalCost, item.leadDays, item.supplierRemarks
        ]);
        row.eachCell((cell: any) => {
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          cell.alignment = { wrapText: true, vertical: 'middle' };
        });
      });
      ws.addRow([]);

      // === COST SUMMARY ===
      const costSummaryHeader = ws.addRow(['Cost Summary']);
      costSummaryHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F9F9F9' } };
      costSummaryHeader.getCell(1).font = { bold: true };
      ws.addRow([]);

      const costSummaryTableHeader = ws.addRow(['Description', 'Amount']);
      costSummaryTableHeader.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      const lineTotalRow = ws.addRow(['Line Total Amount', data.costSummary.lineItemSubtotal]);
      lineTotalRow.eachCell((cell: any) => {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      if (parseFloat(data.costSummary.generalDiscountAmount) > 0) {
        const generalDiscountRow = ws.addRow(['General Discount Amount', `${data.costSummary.generalDiscountAmount}`]);
        generalDiscountRow.eachCell((cell: any) => {
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      }

      let totalAdditionalCharges = 0;
      if (data.costSummary.otherCharges && Array.isArray(data.costSummary.otherCharges)) {
        data.costSummary.otherCharges.forEach((charge: any) => {
          const row = ws.addRow([charge.freightDescription, charge.freightValue]);
          row.eachCell((cell: any) => {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          });
          totalAdditionalCharges += charge.freightValue;
        });
      }

      const totalAdditionalCostRow = ws.addRow(['Total Additional Cost', totalAdditionalCharges]);
      totalAdditionalCostRow.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      if (parseFloat(data.costSummary.taxAmount) > 0) {
        const taxAmountRow = ws.addRow(['Tax Amount', data.costSummary.taxAmount]);
        taxAmountRow.eachCell((cell: any) => {
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      }

      const grandTotalRow = ws.addRow(['Grand Total', `${data.costSummary.grandTotal} ${data.costSummary.currency}`]);
      grandTotalRow.eachCell((cell: any) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
      ws.addRow([]);

      // === TERMS AND CONDITIONS ===
      const termsHeader = ws.addRow(['Terms And Conditions']);
      termsHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
      termsHeader.getCell(1).font = { bold: true };
      ws.addRow([]);
      ws.addRow([data.quoteDetails.termsAndCondition]);
      ws.addRow([]);
      ws.addRow([]);

      // === VSMPS Buyer and Supplier section ===
      ws.addRow([`From VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode || ''}`]);
      ws.addRow([data.buyerDetails.name]);
      ws.addRow([data.buyerDetails.address]);
      ws.addRow([]);
      ws.addRow([`To VSMPS Supplier: ${data.supplierDetails.mpsSupplierCode || ''}`]);
      ws.addRow([data.supplierDetails.name]);
      ws.addRow([data.supplierDetails.address]);
      ws.addRow([]);
      ws.addRow(['Copyright \u00A9 Varuna Sentinels BV. All rights reserved.']);

      // === AUTO WIDTH ===
      const colCount = ws.actualColumnCount;
      for (let i = 1; i <= colCount; i++) {
        let maxLen = 12;
        ws.eachRow({ includeEmpty: true }, (r: any) => {
          const val = r.getCell(i).value;
          const len = val ? val.toString().length : 0;
          if (len > maxLen) maxLen = len;
        });
        ws.getColumn(i).width = Math.min(maxLen + 4, 40);
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, fileName);
    } catch (error) {
      console.error('Error generating service quote Excel:', error);
      this.snack.open('Failed to download service quote Excel.', 'OK', { duration: 3000 });
    } finally {
      this.fullLoaderService.hideLoader();
    }
  }

  convertHtmlToPlainText(html: string): string {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll('li').forEach(li => {
      li.insertAdjacentText('beforebegin', '\n• ');
    });
    const blockTags = ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol'];
    blockTags.forEach(tag => {
      tempDiv.querySelectorAll(tag).forEach(el => {
        el.insertAdjacentText('beforebegin', '\n');
      });
    });
    const text = tempDiv.textContent || '';
    return text.replace(/\n{2,}/g, '\n').trim();
  }

  // ===== PREVIEW / CONTACT =====
  togglePreview(value: boolean, section: string, row?: any) {
    this.previewSection = value;
    this.previewDocs = [];
    if (row && section == 'rfq') {
      this.previewDocs = [...(row.buyerAttachments || []), ...(row.lineItemAttachments || [])];
    } else if (row && section == 'quote') {
      this.previewDocs = [...(row.quoteHeaderAttachments || []), ...(row.quoteLineItemAttachments || [])];
    }
  }

  toggleContactPopUp(value: boolean, row?: any) {
    this.showContactPopup = value;
    if (value && row) {
      this.selectedSupplier = {
        companyName: row.supplierName,
        contactPerson: row.supplierContact,
        email: row.supplierEmail,
        phone: row.supplierPhone,
        address: row.supplierAddress,
        fax: row.supplierFax
      };
    }
  }

  // ===== CHAT =====
  openChat(rfq: any, supplier: any) {
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      vesselEtd: rfq.vesselEtd,
      buyerId: rfq.buyerId || Number(this.cookieService.get('userId')),
      supplierId: supplier.supplierId,
    };
    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }

  get userIdAsString(): string {
    return this.userId.toString();
  }

  // ===== CURRENCY CONVERSION =====
  getConvertedAmount(supplier: any, buyerCurrency: string): string {
    const amount = supplier.totalReqCost;
    if (!amount) return 'N/A';
    if (!this.isWrapDescription) return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    const supplierCurrency = supplier.quoteCurrency || 'EUR';
    if (!supplierCurrency) return `${buyerCurrency ? buyerCurrency : ''} ${amount}`;
    const rates = this.exchangeRatesCache[buyerCurrency];
    if (rates && rates[supplierCurrency]) {
      const converted = (amount * rates[supplierCurrency]).toFixed(3);
      return `${supplierCurrency} ${converted}`;
    }
    return `${buyerCurrency} ${amount}`;
  }

  toggleWrapDescription(event: any, row: any, section: string) {
    if (section == 'quote') {
      this.showQuoteReqCost = event.checked;
      const baseCurrency = row.rfqReqCurrencyCode;
      if (!baseCurrency) {
        this.snack.open('Buyer does not have a currency code', 'Close', { duration: 4000 });
        return;
      }
      if (!this.exchangeRatesCache[baseCurrency]) {
        const url = `https://v6.exchangerate-api.com/v6/${environment.exchangeRate_apiKey}/latest/${baseCurrency}`;
        this.http.get(url).subscribe(
          (res: any) => {
            if (res.result === 'success') {
              this.exchangeRatesCache[baseCurrency] = res.conversion_rates;
            }
          },
          (error: any) => {
            if (error && error.status === 429) {
              this.snack.open('Currency exchange API limit exceeded.', 'OK', { duration: 7000 });
            }
          }
        );
      }
    } else {
      this.showProductReqCost = event.checked;
    }
  }

  // ===== TIMELINE / STAGES =====
  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const rfqStagesList = [
      { name: 'Unactioned', heading: 'RFQ Sent:' },
      { name: 'Expired', heading: 'RFQ Expired:' },
      { name: 'Draft', heading: 'RFQ Drafted:' },
      { name: 'Canceled', heading: 'RFQ Canceled:' },
      { name: 'Created', heading: 'RFQ Created:' },
    ];
    const quoteStagesList = [
      { name: 'Accepted', heading: 'Quotation Recieved' },
      { name: 'Declined', heading: 'Quotation Declined:' },
      { name: 'Draft', heading: 'Quotation Drafted:' },
      { name: 'Quoted', heading: 'Quotation Recieved' },
      { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
    ];
    const list = entityType === 'RFQ' ? rfqStagesList : quoteStagesList;
    const match = list.find(stage => stage.name.toLowerCase() === label.toLowerCase());
    return match ? match.heading : label;
  }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined' || row.docStatus === 'Canceled') return 'stage-declined';
    switch (label) {
      case 'Declined': return 'stage-declined';
      case 'Expired': return 'stage-lapsed';
      default: return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  buildRfqStages(rfq: any) {
    const rfqStatusName = this.rfqStatuses[rfq.rfqStatus - 1];
    rfq.docStatus = rfqStatusName;

    const stagesArray: any[] = [];

    stagesArray.push({
      heading: this.getHeadingFromLabel('Created', 'RFQ'),
      label: 'RFQ Created',
      date: this.formatRfqDate(rfq.rfqDate),
      completed: true,
    });

    stagesArray.push({
      heading: this.getHeadingFromLabel('Unactioned', 'RFQ'),
      label: `RFQ Sent(${rfq.rfqSupplierCount})`,
      date: this.formatDate(rfq.rfqDate),
      completed: true,
    });

    if (rfq.docStatus === 'Unactioned' && this.isRFQExpired(rfq.quotedByDate)) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Expired', 'RFQ'),
        label: 'RFQ Expired',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {
    let stagesArray = rfq.statusesStages || [];
    let quoteCount = rfq.supplierQuotationList?.length || 0;

    if (quoteCount > 0) {
      const lastQuotationDate = rfq.supplierQuotationList[quoteCount - 1]?.quotationDate;
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: `Quotation Received(${quoteCount})`,
        date: lastQuotationDate ? this.formatDate(lastQuotationDate) : '',
        completed: true,
      });
    } else {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Quoted', 'Quote'),
        label: 'Quotation Received(0)',
        date: '',
        completed: false,
      });
    }

    stagesArray.push({ heading: 'PO Created', label: 'PO Created', date: '', completed: false });
    stagesArray.push({ heading: 'PO Confirmation', label: 'PO Confirmation', date: '', completed: false });
    stagesArray.push({ heading: 'Delivered Onboard', label: 'Delivered', date: '', completed: false });

    return stagesArray;
  }

  getRemainingTime(row: any): { label: string; color: string; tooltip: string } {
    if (!row.quotedByDate) return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) return { label: 'New', color: '#0BA716', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 4) return { label: 'Standard', color: '#FD8900', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays >= 1) return { label: 'Urgent', color: '#F60303', tooltip: `RFQ due in ${diffInDays} days` };
    else if (diffInDays < 0) return { label: '-', color: '#000000', tooltip: 'Quote window closed' };
    else return { label: 'Urgent', color: '#F60303', tooltip: 'Due today' };
  }
}
